import { t } from '@app/i18n';
import { DecisionBox, type DialogProps } from './ApproveDialog';

/** **Rejeitar release** — motivo obrigatório: "Informe o motivo da rejeição" (FR-062). */
export function RejectDialog(props: DialogProps) {
  return (
    <DecisionBox
      titulo={t('approvals.dialog.reject.title')}
      obrigatorio
      perigo
      placeholder={t('approvals.dialog.reject.placeholder')}
      confirmar={t('approvals.dialog.reject.confirm')}
      {...props}
    />
  );
}
